import { render } from "./CreateAdmin.vue?vue&type=template&id=38866a77&scoped=true"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"

import "./CreateAdmin.vue?vue&type=style&index=0&id=38866a77&scoped=true&lang=css"
import "./CreateAdmin.vue?vue&type=style&index=1&id=38866a77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38866a77"]])

export default __exports__